import React from 'react';

/**
 * Multi-line text input component with label
 * Design: High-contrast borders, monospace font
 */
export default function TextArea({
  label,
  id,
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  rows = 4,
  maxLength,
  className = '',
  ...props
}) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={inputId}
          className="block font-mono text-sm font-semibold uppercase tracking-wider mb-2 text-black"
        >
          {label}
          {required && <span className="text-red-600 ml-1">*</span>}
        </label>
      )}
      <textarea
        id={inputId}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        rows={rows}
        maxLength={maxLength}
        className={`
          w-full px-4 py-3
          border-2 border-black
          bg-white text-black
          font-mono text-sm
          placeholder:text-gray-400
          resize-vertical
          focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2
          disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-red-600 focus:ring-red-600' : ''}
        `}
        {...props}
      />
      <div className="flex justify-between mt-2">
        {error ? (
          <p className="font-mono text-xs text-red-600 uppercase tracking-wider">
            {error}
          </p>
        ) : (
          <span />
        )}
        {maxLength && (
          <p className="font-mono text-xs text-gray-500">
            {value?.length || 0}/{maxLength}
          </p>
        )}
      </div>
    </div>
  );
}
